/* eslint-disable camelcase */
import { SET_FILES, SET_FILES_ERROR, SET_ORDER } from "../constants";

const initialState = {
  error: [],
  files: {
    id_front: {
      src: null,
      type: "id_front",
    },
    id_back: {
      src: null,
      type: "id_back",
    },
    selfie: {
      src: null,
      type: "selfie",
    },
    proof_of_residence: {
      src: null,
      type: "proof_of_residence",
    },
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ORDER: {
      const { files } = action.payload;
      if (files) {
        const id_front = { ...state.files.id_front, ...(files.id_front || {}) };
        const id_back = { ...state.files.id_back, ...(files.id_back || {}) };
        const selfie = { ...state.files.selfie, ...(files.selfie || {}) };
        const proof_of_residence = {
          ...state.files.proof_of_residence,
          ...(action.payload.proofOfResidence || {}),
        };
        return {
          ...state,
          files: {
            id_front,
            id_back,
            selfie,
            proof_of_residence,
          },
        };
      }
    }

    case SET_FILES: {
      const { files } = state;
      files[action.payload.type] = action.payload;
      return {
        ...state,
        files,
      };
    }

    case SET_FILES_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};
